import {HOURS_PER_DAY, MINUTES_PER_HOUR} from '@eitje/utils'
import {DEFAULT_TIME_PICKER_MINUTE_STEP, TIME_STRING_PATTERN} from './constants'

export const getMinuteValues = minuteStep => {
	const normalizedMinuteStep = minuteStep > 0 ? Math.min(minuteStep, MINUTES_PER_HOUR) : DEFAULT_TIME_PICKER_MINUTE_STEP

	return Array.from({length: MINUTES_PER_HOUR}, (_, minute) => minute).filter(minute => minute % normalizedMinuteStep === 0)
}

// Converts a given hour and minute to its numeric representation (= amount of minutes since midnight)
// 00:00 -> 0, 12:00 -> 720, 23:59 -> 1439
export const toNumericTime = (hour, minute) => hour * MINUTES_PER_HOUR + minute

export const parseTime = value => {
	if (!isValidTimeString(value)) return null

	const [hour, minute] = value.split(':').map(Number)
	return toNumericTime(hour, minute)
}

export const getHourFromNumericTime = time => Math.floor(time / MINUTES_PER_HOUR)

export const getMinuteFromNumericTime = time => time % MINUTES_PER_HOUR

export const formatNumericTime = timeAsNumeric =>
	`${String(getHourFromNumericTime(timeAsNumeric)).padStart(2, '0')}:${String(getMinuteFromNumericTime(timeAsNumeric)).padStart(2, '0')}`

const isValidHour = hour => Number.isInteger(hour) && hour >= 0 && hour < HOURS_PER_DAY
const isValidMinute = minute => Number.isInteger(minute) && minute >= 0 && minute < MINUTES_PER_HOUR

export const isValidTimeString = value => {
	if (typeof value !== 'string' || !TIME_STRING_PATTERN.test(value)) return false

	const [hour, minute] = value.split(':')

	return isValidHour(Number(hour)) && isValidMinute(Number(minute))
}
